import { Settings as SettingsIcon } from "lucide-react";
import InfoBanner from "../ui/InfoBanner";
import CopyableInput from "../ui/CopyableInput";
import CheckboxGroup from "../ui/CheckboxGroup";
import { EVENT_TYPE_OPTIONS } from "../constants/connectionMethods";

export default function WebhookConnection({
  webhookUrl,
  eventTypes,
  setEventTypes,
  retryPolicy,
  setRetryPolicy
}) {
  const handleEventTypeChange = (eventId, checked) => {
    setEventTypes({
      ...eventTypes,
      [eventId]: checked
    });
  };

  return (
    <>
      {/* Webhook Info */}
      <InfoBanner
        icon={SettingsIcon}
        title="Webhook Events"
        description="Receive real-time notifications for data updates and events."
      />

      {/* Webhook URL */}
      <CopyableInput label="Webhook URL" value={webhookUrl} />

      {/* Event Types */}
      <CheckboxGroup
        label="Event Types"
        options={EVENT_TYPE_OPTIONS}
        values={eventTypes}
        onChange={handleEventTypeChange}
      />

      {/* Retry Policy */}
      <div>
        <label className="block text-sm font-semibold text-gray-900 mb-2">
          Retry Policy
        </label>
        <select
          value={retryPolicy}
          onChange={(e) => setRetryPolicy(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
        >
          <option value="exponential">Exponential backoff (Recommended)</option>
          <option value="linear">Linear backoff</option>
          <option value="fixed">Fixed interval</option>
          <option value="none">No retry</option>
        </select>
      </div>
    </>
  );
}
